import React, {ReactNode} from 'react';
import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {Housing} from '@guestapp/sdk';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {Navbar} from './Components/Navbar';
import {Footer} from './Components/Footer';
import {PageWrapper, Wrapper} from './styled';

type PageUniversalLinkProps = {
  children: ReactNode;
  className?: string;
};

const defaultProps: PageUniversalLinkProps = {
  children: '',
};

function PageUniversalLink({children, className}: PageUniversalLinkProps) {
  const {objectId, getHousing} = useChekinSDK();
  const housingId = objectId;

  const {data: housing} = useQuery<Housing, Error>(
    [QUERY_CACHE_KEYS.housing],
    () => getHousing(housingId || ''),
    {
      initialData: {} as Housing,
      enabled: Boolean(housingId),
    },
  );

  const logo = housing.picture?.src;
  const title = housing.display_name ?? housing.name;

  return (
    <PageWrapper>
      <Navbar title={title} logo={logo} />
      <Wrapper className={'page_content ' + className}>{children}</Wrapper>
      <Footer />
    </PageWrapper>
  );
}

PageUniversalLink.defaultProps = defaultProps;

export {PageUniversalLink};
